import { createBrowserRouter, Navigate } from 'react-router-dom';
import SpaCreatePostPage from './pages/SpaCreatePostPage';
import SpaGameDeepLinkPage, { loadBangdreamDetail } from './pages/SpaGameDeepLinkPage';
import SpaGameShellPage from './pages/SpaGameShellPage';
import SpaGuidePage from './pages/SpaGuidePage';
import SpaPlatformProfilePage from './pages/SpaPlatformProfilePage';
import SpaPortalPage from './pages/SpaPortalPage';
import SpaProfilePage from './pages/SpaProfilePage';
import SpaSearchPage from './pages/SpaSearchPage';
import SpaUserPostsPage from './pages/SpaUserPostsPage';
import PortalV3 from '../components/portal-v3';

/**
 * SPA 路由表。path 必须与 lib/spa-routes.ts / App Router 对齐。
 * 爬虫不走此表，仍由 vinext SSR 出 HTML。
 */
export const spaRouter = createBrowserRouter([
  {
    path: '/',
    element: <SpaPortalPage />,
  },
  {
    path: '/portal-v3',
    element: <PortalV3 />,
  },
  {
    path: '/legacy-home',
    element: <SpaPortalPage />,
  },
  {
    path: '/wikis',
    element: <SpaPortalPage />,
  },
  {
    path: '/updates',
    element: <SpaPortalPage />,
  },
  {
    path: '/characters',
    element: <SpaPortalPage />,
  },
  {
    path: '/profile',
    element: <SpaPlatformProfilePage />,
  },
  {
    path: '/user/:uid',
    element: <SpaUserPostsPage />,
  },
  {
    path: '/:game/guide/:postId/edit',
    element: <SpaCreatePostPage channel="edit" />,
  },
  {
    path: '/:game/guide-legacy/:postId',
    element: <SpaGuidePage legacy />,
  },
  {
    path: '/:game/guide-v2/:postId',
    element: <SpaGuidePage legacy={false} />,
  },
  {
    path: '/:game/guide/:postId',
    element: <SpaGuidePage />,
  },
  {
    path: '/:game/dcommunity/create',
    element: <SpaCreatePostPage channel="community" />,
  },
  {
    path: '/:game/dguides/create',
    element: <SpaCreatePostPage channel="guide" />,
  },
  {
    path: '/:game/dcatalog/:catalog',
    element: <SpaGameShellPage />,
  },
  {
    path: '/:game/dcatalog',
    element: <SpaGameShellPage />,
  },
  {
    path: '/:game/dguides',
    element: <SpaGameShellPage />,
  },
  {
    path: '/:game/dtools',
    element: <SpaGameShellPage />,
  },
  {
    path: '/:game/dcommunity',
    element: <SpaGameShellPage />,
  },
  {
    path: '/:game/dbenefits',
    element: <SpaGameShellPage />,
  },
  {
    path: '/:game/search',
    element: <SpaSearchPage />,
  },
  {
    path: '/:game/profile',
    element: <SpaProfilePage />,
  },
  {
    path: '/:game/:route',
    loader: loadBangdreamDetail,
    element: <SpaGameDeepLinkPage />,
  },
  {
    path: '/:game',
    element: <SpaGameShellPage />,
  },
  {
    path: '*',
    element: <Navigate to="/" replace />,
  },
]);
